import type { IconJVSProps } from '@mairistem/composants';
import React from 'react';
import type TypeRegroupement from '../../constants/feuilleSaisie/typeRegroupement';
import TypePeriode from '../../constants/simulation/typePeriode';
import type TreeRow from '../../interfaces/feuilleSaisie/treeRow';
import { getMontantImputation } from '../../utils/feuilleSaisie/imputation';
import type BaseFeuilleSaisie from '../feuilleSaisies/BaseFeuilleSaisie';

class BaseTypeRegroupement {
	code: TypeRegroupement;

	libelle: string;

	// nom de la colone en base de données qui contient le code
	codeColumnName: string;

	// libelle de la colonne en base de données qui contient le libelle
	libelleColumnName: string;

	icon: IconJVSProps;

	getKey(data: TreeRow): string {
		return this.code + data[this.codeColumnName];
	}

	getLibelle(data: TreeRow, _feuille: BaseFeuilleSaisie): string {
		return `${data[this.codeColumnName] ?? ''} - ${data[this.libelleColumnName] ?? ''}`;
	}

	getTabLibelle(data: TreeRow): React.JSX.Element {
		return (
			<>
				<div>{data[this.codeColumnName] ?? ''}</div>
				{data[this.libelleColumnName] ?? ''}
			</>
		);
	}

	getSolde(data: TreeRow) {
		return {
			libelle: 'TOTAL',
			...data?.children?.reduce(
				(prev, next) => ({
					budget: prev.budget + next.budget,
					realise: prev.realise + next.realise,
					report: prev.report + next.report,
					rar: prev.rar + next.rar,
					engage_n: prev.engage_n + next.engage_n,
					liquide_n: prev.liquide_n + next.liquide_n,
					solde: prev.solde + next.solde,
					montantDemande:
						prev.montantDemande +
						getMontantImputation(next, TypePeriode.DEMANDE),
					montantProp:
						prev.montantProp + getMontantImputation(next, TypePeriode.PROPOSE),
					montantVote:
						prev.montantVote + getMontantImputation(next, TypePeriode.VOTE),
				}),
				{
					budget: 0,
					realise: 0,
					montantDemande: 0,
					montantProp: 0,
					montantVote: 0,
					report: 0,
					rar: 0,
					engage_n: 0,
					liquide_n: 0,
					solde: 0,
				},
			),
		};
	}
}

export default BaseTypeRegroupement;
